import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
import type { ApiResponse } from 'vopay';

const { api } = vopayApi;

export default function useBlockAccounts() {
  const source = axios.CancelToken.source();
  const [blockLoading, setBlockLoading] = useState(false);
  const [unblockLoading, setUnblockLoading] = useState(false);

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  async function blockAccounts(): Promise<ApiResponse> {
    try {
      setBlockLoading(true);

      const res = await api.blockAccounts(source);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (err) {
      console.error('Block accounts failed:', err);
      throw err;
    } finally {
      setBlockLoading(false);
    }
  }

  async function unblockAccounts(): Promise<ApiResponse> {
    try {
      setUnblockLoading(true);

      const res = await api.unblockAccounts(source);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (err) {
      console.error('Unblock accounts failed:', err);
      throw err;
    } finally {
      setUnblockLoading(false);
    }
  }

  return {
    blockLoading,
    unblockLoading,
    blockAccounts,
    unblockAccounts,
  };
}
